"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let CreateProduct = class CreateProduct extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
        this.$$cache_item = new core_1.ComponentValueCache(this, "item", "Product.create");
    }
    preventDefaultOnClose;
    onPrevent_default_on_close(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("preventDefaultOnClose");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    item;
    async $$load_item() {
        return this.$fn.schemaDefaults('CreateProduct', { sync: true });
    }
    formName;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    resource;
    async $$load_resource() {
        return new this.$fn.Resource(this.item);
    }
    editor;
    async $$load_editor() {
        return this.resource.editor();
    }
    container;
    async $$load_container() {
        return {
            self: this.$fn.urlFor('create_product'),
            object: 'list',
            data: []
        };
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['item', 'formName', 'formId', 'resource', 'editor', 'container', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                item: null,
                formName: "meter",
                formId: null,
                resource: null,
                editor: null,
                container: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
            },
        };
    }
    get resourceTitle() {
        if (this.loaded) {
            return this.$fn.pgettext("Product", "Product");
        }
        return null;
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("Product", "New product"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3964_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_setData_3970_getActionArgs($event) {
        return {
            path: "item",
            value: this.editor.getData(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_1040167445267876_closeComponent_3972_getActionArgs($event) {
        return {
            result: {
                ok: true,
                value: $event.data.response.data,
            },
        };
    }
    async act_1040167445267876_navigate_3974_getActionArgs($event) {
        return {
            location: {
                name: "app.product",
                params: {
                    id: $event.data.response.data.id,
                },
            },
        };
    }
    async evh_1040167445267876_created_3973_getWhen($event) {
        return !this.preventDefaultOnClose;
    }
    async act_1040167445267876_reloadSlickgrid_3976_getActionArgs($event) {
        return {
            grid: "products",
        };
    }
    async evh_1040167445267876_created_3975_getWhen($event) {
        return !this.preventDefaultOnClose;
    }
    async act_1040167445267876_rest_3968_getActionArgs($event) {
        return {
            method: "save",
            container: this.container,
            resource: this.editor,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_2186679009640457_clickPreventStop(event, scope) {
        return await this.actions.evh_2186679009640457_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3964 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3964_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3963 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3964,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3963],
        });
        const act_2248226175642056_closeModal_3966 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_2248226175642056_close_3965 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeModal_3966,
            event: "close",
            displayName: "closeModal",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_3965],
        });
        const act_1040167445267876_setData_3970 = new core_1.actions.SetDataAction({
            actionArgs: this.act_1040167445267876_setData_3970_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_before_3969 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_setData_3970,
            event: "before",
            displayName: "setData",
        });
        const act_1040167445267876_closeComponent_3972 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1040167445267876_closeComponent_3972_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_created_3971 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeComponent_3972,
            event: "created",
            displayName: "closeComponent",
        });
        const act_1040167445267876_navigate_3974 = new core_1.actions.NavigateAction({
            actionArgs: this.act_1040167445267876_navigate_3974_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_created_3973 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_navigate_3974,
            event: "created",
            when: this.evh_1040167445267876_created_3973_getWhen,
            displayName: "navigate",
        });
        const act_1040167445267876_reloadSlickgrid_3976 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_1040167445267876_reloadSlickgrid_3976_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_created_3975 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_reloadSlickgrid_3976,
            event: "created",
            when: this.evh_1040167445267876_created_3975_getWhen,
            displayName: "reloadSlickgrid",
        });
        const act_1040167445267876_rest_3968 = new core_1.actions.RestAction({
            actionArgs: this.act_1040167445267876_rest_3968_getActionArgs,
            displayName: "create",
            events: [evh_1040167445267876_before_3969, evh_1040167445267876_created_3971, evh_1040167445267876_created_3973, evh_1040167445267876_created_3975],
        });
        const evh_1040167445267876_submit_3967 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_rest_3968,
            event: "submit",
            displayName: "create",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_3967],
        });
        const act_2186679009640457_closeComponent_3978 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2186679009640457_clickPreventStop_3977 = new core_1.actions.EventHandlerImpl({
            action: act_2186679009640457_closeComponent_3978,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_2186679009640457_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2186679009640457_clickPreventStop_3977],
        });
        return {
            act_7315092382398562_closeModal_3964,
            evh_7315092382398562_close_3963,
            evh_7315092382398562_close,
            act_2248226175642056_closeModal_3966,
            evh_2248226175642056_close_3965,
            evh_2248226175642056_close,
            act_1040167445267876_setData_3970,
            evh_1040167445267876_before_3969,
            act_1040167445267876_closeComponent_3972,
            evh_1040167445267876_created_3971,
            act_1040167445267876_navigate_3974,
            evh_1040167445267876_created_3973,
            act_1040167445267876_reloadSlickgrid_3976,
            evh_1040167445267876_created_3975,
            act_1040167445267876_rest_3968,
            evh_1040167445267876_submit_3967,
            evh_1040167445267876_submit,
            act_2186679009640457_closeComponent_3978,
            evh_2186679009640457_clickPreventStop_3977,
            evh_2186679009640457_clickPreventStop,
            create: act_1040167445267876_rest_3968,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], CreateProduct.prototype, "preventDefaultOnClose", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('preventDefaultOnClose'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreateProduct.prototype, "onPrevent_default_on_close", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], CreateProduct.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreateProduct.prototype, "onSize", null);
CreateProduct = __decorate([
    (0, vue_property_decorator_1.Component)()
], CreateProduct);
exports.default = CreateProduct;
vue_property_decorator_1.Vue.component("CreateProduct", CreateProduct);
